module.exports = __webpack_public_path__ + "static/media/sinapi-logo-white-without-tagline.991dc5cf.svg";